// extracted by mini-css-extract-plugin
export default {"loadingScreen":"LoadingScreen_loadingScreen__ADAAq"};